export const NOTIFICATIONS = [
  {
    key: 'referral_round_up_email',
    heading: 'notificationSettings.referralRoundUp',
    description: 'notificationSettings.referralRoundUpDesc',
  },
];

export const NOTIFICATION_SETTINGS = [
  {
    key: 'referral_status_updates',
    heading: 'notificationSettings.referralStatusUpdates',
    description: 'notificationSettings.referralStatusUpdatesDesc',
  },
  {
    key: 'application_status_updates',
    heading: 'notificationSettings.applicationStatusUpdates',
    description: 'notificationSettings.applicationStatusUpdatesDesc',
  },
  {
    key: 'reward_updates',
    heading: 'notificationSettings.rewardUpdates',
    description: 'notificationSettings.rewardUpdatesDesc',
  },
  {
    key: 'leaderboard_updates',
    heading: 'notificationSettings.leaderboardUpdates',
    description: 'notificationSettings.leaderboardUpdatesDesc',
  },
  {
    key: 'recommendations',
    heading: 'notificationSettings.recommendations',
    description: 'notificationSettings.recommendationsDesc',
  },
  {
    key: 'product_updates',
    heading: 'notificationSettings.productUpdates',
    description: 'notificationSettings.productUpdatesDesc',
  },
  {
    key: 'account_management',
    heading: 'notificationSettings.accountManagement',
    description: 'notificationSettings.accountManagementDesc',
  },
  {
    key: 'company_related_content',
    heading: 'notificationSettings.companyRelatedContent',
    description: 'notificationSettings.companyRelatedContentDesc',
  },
  {
    key: 'referral_round_up',
    heading: 'notificationSettings.referralRoundUp',
    description: 'notificationSettings.referralRoundUpDesc',
  },
];
export const DISABLED_NOTIFICATIONS = [
  'referral_status_updates_email',
  'leaderboard_updates_email',
  'recommendations_email',
  'application_status_updates_email',
  'product_updates_email',
  'reward_updates_email',
  'account_management_email',
  'company_related_content_email',
  'referral_round_up_sms',
];
